import { constants } from '@/config';

const App = () => import('@/app/twitter/App.vue');
const Overview = () => import('@/app/analytics/pages/ChannelOverviewPage.vue');
const BoardsIndex = () => import('@/app/boards/pages/BoardsIndex.vue');
const AnalyticsYourPostsPage = () => import('@/app/analytics/pages/AnalyticsYourPostsPage.vue');

const PAGE_LEVEL_TOP = `Twitter`;

export default {
  path: 'x',
  component: App,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      name: 'twitter',
      path: '',
      redirect: { name: 'twitter.overview' },
    },
    {
      name: 'twitter.dashboard',
      path: 'dashboard',
      component: Overview,
      redirect: { name: 'twitter.overview' },
    },
    {
      name: 'twitter.dashboard.report',
      path: 'dashboard/report',
      component: Overview,
      meta: {
        report: true,
      },
      redirect: { name: 'twitter.overview.report' },
    },
    {
      name: 'twitter.overview',
      path: 'overview',
      component: Overview,
      props: { channel: constants.TWITTER, key: constants.TWITTER },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'twitter.overview.report',
      path: 'overview/report',
      component: Overview,
      props: { channel: constants.TWITTER, key: constants.TWITTER },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview Report`,
        report: true,
      },
    },
    {
      path: 'your-tweets',
      redirect: {
        name: 'twitter.yourTweets',
      },
    },
    {
      name: 'twitter.yourTweets',
      path: 'your-posts',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.TWITTER,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts`,
      },
    },
    {
      name: 'twitter.yourTweets.report',
      path: 'your-posts/report',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.TWITTER,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts Report`,
        report: true,
      },
    },
    {
      path: 'boards',
      children: [
        {
          name: 'twitter.galleries',
          path: '',
          component: BoardsIndex,
          props: {
            galleryType: constants.TWITTER,
          },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Boards`,
          },
        },
      ],
    },
  ],
};
